module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-BoldItalic_c28d2711.f1a65155.ttf";